function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import * as utils from './utils';
import NavigateBefore from '@material-ui/icons/NavigateBefore';
import NavigateNext from '@material-ui/icons/NavigateNext';
import GetAppIcon from '@material-ui/icons/GetApp';
import Close from '@material-ui/icons/Close';
import { CircularProgress } from '@material-ui/core';
import Img from "./img";

var imagesType = ['jpg', 'jpeg', 'png', 'gif', 'JPG', 'JPEG', 'PNG', 'GIF', 'webp'];
var docType = ['doc', 'docx', 'pdf', 'PDF', 'ppt', 'pptx', 'xlx', 'xlsx'];

var PdfIcon = "http://dialogueinlive.s3.us-east-2.amazonaws.com/DocIcon/pdf.png";
var DocIcon = 'http://dialogueinlive.s3.us-east-2.amazonaws.com/DocIcon/doc.png';
var PptIcon = "http://dialogueinlive.s3.us-east-2.amazonaws.com/DocIcon/powerpoint.png";
var ExcelIcon = "http://dialogueinlive.s3.us-east-2.amazonaws.com/DocIcon/excel.png";

var MIN_SCALE = 1;
var MAX_SCALE = 4;
var SETTLE_RANGE = 0.001;
var ADDITIONAL_LIMIT = 0.2;
var DOUBLE_TAP_THRESHOLD = 300;
var ANIMATION_SPEED = 0.04;
var RESET_ANIMATION_SPEED = 0.08;
var INITIAL_X = 0;
var INITIAL_Y = 0;
var INITIAL_SCALE = 1;
var MOBILE_ICON_SIZE = 35;
var DESKTOP_ICON_SIZE = 50;

var ReactImageVideoLightbox = function (_React$Component) {
    _inherits(ReactImageVideoLightbox, _React$Component);

    function ReactImageVideoLightbox() {
        _classCallCheck(this, ReactImageVideoLightbox);

        var _this = _possibleConstructorReturn(this, _React$Component.apply(this, arguments));

        _this.state = {
            x: INITIAL_X,
            y: INITIAL_Y,
            scale: INITIAL_SCALE,
            width: window.innerWidth,
            height: window.innerHeight,
            index: _this.props.startIndex,
            swiping: false,
            loading: true,
            iconSize: window.innerWidth <= 500 ? MOBILE_ICON_SIZE : DESKTOP_ICON_SIZE
        };

        _this.width = window.innerWidth;
        _this.height = window.innerHeight;
        _this.handleTouchStart = _this.handleTouchStart.bind(_this);
        _this.handleTouchMove = _this.handleTouchMove.bind(_this);
        _this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
        return _this;
    }

    ReactImageVideoLightbox.prototype.zoomTo = function zoomTo(scale) {
        var _this2 = this;

        var frame = function frame() {
            if (_this2.state.scale === scale) return null;

            var distance = scale - _this2.state.scale;
            var targetScale = _this2.state.scale + ANIMATION_SPEED * distance;

            _this2.zoom(utils.settle(targetScale, scale, SETTLE_RANGE));
            _this2.animation = requestAnimationFrame(frame);
        };

        this.animation = requestAnimationFrame(frame);
    };

    ReactImageVideoLightbox.prototype.reset = function reset() {
        var _this3 = this;

        var frame = function frame() {
            if (_this3.state.scale === INITIAL_SCALE && _this3.state.x === INITIAL_X && _this3.state.y === INITIAL_Y) return null;

            var scaleDelta = INITIAL_SCALE - _this3.state.scale;
            var targetScale = utils.settle(_this3.state.scale + RESET_ANIMATION_SPEED * scaleDelta, INITIAL_SCALE, SETTLE_RANGE);

            var nextWidth = _this3.width * targetScale;
            var nextHeight = _this3.height * targetScale;

            _this3.setState({
                scale: targetScale,
                width: nextWidth,
                height: nextHeight,
                x: INITIAL_X,
                y: INITIAL_Y
            }, function () {
                _this3.animation = requestAnimationFrame(frame);
            });
        };

        this.animation = requestAnimationFrame(frame);
    };

    ReactImageVideoLightbox.prototype.handleTouchStart = function handleTouchStart(event) {
        this.animation && cancelAnimationFrame(this.animation);
        if (event.touches.length === 2) this.handlePinchStart(event);
        if (event.touches.length === 1) this.handleTapStart(event);
    };

    ReactImageVideoLightbox.prototype.handleTouchMove = function handleTouchMove(event) {
        if (event.touches.length === 2) this.handlePinchMove(event);
        if (event.touches.length === 1) this.handlePanMove(event);
    };

    ReactImageVideoLightbox.prototype.handleTouchEnd = function handleTouchEnd(event) {
        if (event.touches.length > 0) return null;

        if (this.state.scale > MAX_SCALE) return this.zoomTo(MAX_SCALE);
        if (this.state.scale < MIN_SCALE) return this.zoomTo(MIN_SCALE);

        if (this.lastTouchEnd && this.lastTouchEnd + DOUBLE_TAP_THRESHOLD > event.timeStamp) {
            this.reset();
        }

        if (this.state.swiping && this.state.scale === 1) {
            this.handleSwipe(event);
        }

        this.lastTouchEnd = event.timeStamp;
    };

    ReactImageVideoLightbox.prototype.handleSwipe = function handleSwipe(event) {
        var swipeDelta = event.changedTouches[0].clientX - this.swipeStartX;
        if (swipeDelta < -(this.width / 3)) {
            this.swipeRight(event.target);
        } else if (swipeDelta > this.width / 3) {
            this.swipeLeft(event.target);
        } else {
            this.reset();
        }
    };

    ReactImageVideoLightbox.prototype.swipeLeft = function swipeLeft() {
        var _this4 = this;

        var currentIndex = this.state.index;
        if (currentIndex > 0) {
            setTimeout(function () {
                _this4.setState({
                    index: currentIndex - 1,
                    swiping: false,
                    x: INITIAL_X,
                    loading: false
                });
            }, 500);
        } else {
            this.reset();
        }
    };

    ReactImageVideoLightbox.prototype.swipeRight = function swipeRight() {
        var _this5 = this;

        var currentIndex = this.state.index;
        if (currentIndex < this.props.data.length - 1) {
            setTimeout(function () {
                _this5.setState({
                    index: currentIndex + 1,
                    swiping: false,
                    x: INITIAL_X,
                    loading: true
                });
            }, 500);
        } else {
            this.reset();
        }
    };

    ReactImageVideoLightbox.prototype.handleTapStart = function handleTapStart(event) {
        this.swipeStartX = event.touches[0].clientX;
        this.swipeStartY = event.touches[0].clientY;
        if (this.state.scale === 1) {
            this.setState({
                swiping: true
            });
        }
    };

    ReactImageVideoLightbox.prototype.handlePanMove = function handlePanMove(event) {
        if (this.state.scale === 1) {
            this.setState({
                x: event.touches[0].clientX - this.swipeStartX
            });
        } else {
            event.preventDefault();
            this.setState({
                x: event.touches[0].clientX - this.swipeStartX,
                y: event.touches[0].clientY - this.swipeStartY
            });
        }
    };

    ReactImageVideoLightbox.prototype.handlePinchStart = function handlePinchStart(event) {
        var pointA = utils.getPointFromTouch(event.touches[0]);
        var pointB = utils.getPointFromTouch(event.touches[1]);
        this.lastDistance = utils.getDistanceBetweenPoints(pointA, pointB);
    };

    ReactImageVideoLightbox.prototype.handlePinchMove = function handlePinchMove(event) {
        event.preventDefault();
        var pointA = utils.getPointFromTouch(event.touches[0]);
        var pointB = utils.getPointFromTouch(event.touches[1]);
        var distance = utils.getDistanceBetweenPoints(pointA, pointB);
        var scale = utils.between(MIN_SCALE - ADDITIONAL_LIMIT, MAX_SCALE + ADDITIONAL_LIMIT, this.state.scale * (distance / this.lastDistance));
        this.zoom(scale);
        this.lastDistance = distance;
    };

    ReactImageVideoLightbox.prototype.zoom = function zoom(scale) {
        var nextWidth = this.width * scale;
        var nextHeight = this.height * scale;

        this.setState({
            width: nextWidth,
            height: nextHeight,
            scale: scale
        });
    };

    ReactImageVideoLightbox.prototype.getResources = function getResources() {
        var _this6 = this;

        var items = [];
        var data = this.props.data;
        for (var i = 0; i < data.length; i++) {
            var resource = data[i];
            var resourceType = resource.split('.').pop();
            if (imagesType.filter(function (item) {
                return item === resource.split('.').pop();
            }).length > 0) {
                items.push(React.createElement(Img, { key: i,
                    alt: resource.altTag,
                    src: resource,
                    style: {
                        pointerEvents: this.state.scale === 1 ? 'auto' : 'none',
                        maxWidth: '100%',
                        maxHeight: '100%',
                        transform: 'translate(' + this.state.x + 'px, ' + this.state.y + 'px) scale(' + this.state.scale + ')',
                        transition: 'transform 0.5s ease-out'
                    },
                    onLoad: function onLoad() {
                        _this6.setState({ loading: false });
                    } }));
            } else if (resourceType == 'doc' || resourceType == 'docx') {
                items.push(React.createElement(
                    'div',
                    { key: i },
                    React.createElement(Img, {
                        alt: resource.altTag,
                        src: DocIcon,
                        style: {
                            pointerEvents: this.state.scale === 1 ? 'auto' : 'none',
                            maxWidth: '100%',
                            maxHeight: '100%',
                            transform: 'translate(' + this.state.x + 'px, ' + this.state.y + 'px) scale(' + this.state.scale + ')',
                            transition: 'transform 0.5s ease-out'
                        },
                        onLoad: function onLoad() {
                            _this6.setState({ loading: false });
                        } }),
                    React.createElement(
                        'a',
                        { href: resource, target: '_blank' },
                        React.createElement(GetAppIcon, {
                            style: {
                                position: 'absolute',
                                right: '55px',
                                top: '14px',
                                zIndex: 1,
                                color: '#FFFFFF',
                                cursor: 'pointer',
                                fontSize: '25px'
                            },
                            onClick: function onClick() {} }),
                        ' '
                    )
                ));
            } else if (resourceType == 'pdf' || resourceType == 'PDF') {
                items.push(React.createElement(
                    'div',
                    { key: i },
                    React.createElement(Img, {
                        alt: resource.altTag,
                        src: PdfIcon,
                        style: {
                            pointerEvents: this.state.scale === 1 ? 'auto' : 'none',
                            maxWidth: '100%',
                            maxHeight: '100%',
                            transform: 'translate(' + this.state.x + 'px, ' + this.state.y + 'px) scale(' + this.state.scale + ')',
                            transition: 'transform 0.5s ease-out'
                        },
                        onLoad: function onLoad() {
                            _this6.setState({ loading: false });
                        } }),
                    React.createElement(
                        'a',
                        { href: resource, target: '_blank' },
                        React.createElement(GetAppIcon, {
                            style: {
                                position: 'absolute',
                                right: '55px',
                                top: '14px',
                                zIndex: 1,
                                color: '#FFFFFF',
                                cursor: 'pointer',
                                fontSize: '25px'
                            },
                            onClick: function onClick() {} }),
                        ' '
                    )
                ));
            } else if (resourceType == 'ppt' || resourceType == 'pptx') {
                items.push(React.createElement(
                    'div',
                    { key: i },
                    React.createElement(Img, {
                        alt: resource.altTag,
                        src: PptIcon,
                        style: {
                            pointerEvents: this.state.scale === 1 ? 'auto' : 'none',
                            maxWidth: '100%',
                            maxHeight: '100%',
                            transform: 'translate(' + this.state.x + 'px, ' + this.state.y + 'px) scale(' + this.state.scale + ')',
                            transition: 'transform 0.5s ease-out'
                        },
                        onLoad: function onLoad() {
                            _this6.setState({ loading: false });
                        } }),
                    React.createElement(
                        'a',
                        { href: resource, target: '_blank' },
                        React.createElement(GetAppIcon, {
                            style: {
                                position: 'absolute',
                                right: '55px',
                                top: '14px',
                                zIndex: 1,
                                color: '#FFFFFF',
                                cursor: 'pointer',
                                fontSize: '25px'
                            },
                            onClick: function onClick() {} }),
                        ' '
                    )
                ));
            } else if (resourceType == 'xlx' || resourceType == 'xlsx') {
                items.push(React.createElement(
                    'div',
                    { key: i },
                    React.createElement(Img, {
                        alt: resource.altTag,
                        src: ExcelIcon,
                        style: {
                            pointerEvents: this.state.scale === 1 ? 'auto' : 'none',
                            maxWidth: '100%',
                            maxHeight: '100%',
                            transform: 'translate(' + this.state.x + 'px, ' + this.state.y + 'px) scale(' + this.state.scale + ')',
                            transition: 'transform 0.5s ease-out'
                        },
                        onLoad: function onLoad() {
                            _this6.setState({ loading: false });
                        } }),
                    React.createElement(
                        'a',
                        { href: resource, target: '_blank' },
                        React.createElement(GetAppIcon, {
                            style: {
                                position: 'absolute',
                                right: '55px',
                                top: '14px',
                                zIndex: 1,
                                color: '#FFFFFF',
                                cursor: 'pointer',
                                fontSize: '25px'
                            },
                            onClick: function onClick() {} }),
                        ' '
                    )
                ));
            } else {
                items.push(React.createElement('video', { controls: true, src: resource,
                    autoPlay: true,
                    preload: 'auto',
                    onLoadEnd: function onLoadEnd() {
                        return _this6.setState({ loading: false });
                    } }));
            }
        }

        return items;
    };

    ReactImageVideoLightbox.prototype.componentWillMount = function componentWillMount() {
        var _this7 = this;

        window.addEventListener('resize', function () {
            if (window.innerWidth <= 500) {
                _this7.setState({ iconSize: MOBILE_ICON_SIZE });
            } else {
                _this7.setState({ iconSize: DESKTOP_ICON_SIZE });
            }
        });
    };

    ReactImageVideoLightbox.prototype.componentWillUnmount = function componentWillUnmount() {
        var _this8 = this;

        window.removeEventListener('resize', function () {
            if (window.innerWidth <= 500) {
                _this8.setState({ iconSize: MOBILE_ICON_SIZE });
            } else {
                _this8.setState({ iconSize: DESKTOP_ICON_SIZE });
            }
        });
    };

    ReactImageVideoLightbox.prototype.render = function render() {
        var _this9 = this;

        var resources = this.getResources();
        return React.createElement(
            'div',
            {
                onTouchStart: this.handleTouchStart,
                onTouchMove: this.handleTouchMove,
                onTouchEnd: this.handleTouchEnd,
                style: {
                    top: '0px',
                    left: '0px',
                    overflow: 'hidden',
                    position: 'absolute',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',
                    height: '100%',
                    width: '100%',
                    backgroundColor: 'rgba(0,0,0,1)'
                } },
            this.props.showResourceCount && React.createElement(
                'div',
                {
                    style: {
                        position: 'absolute',
                        top: '0px',
                        left: '0px',
                        padding: '15px',
                        color: 'white',
                        fontWeight: 'bold'
                    } },
                React.createElement(
                    'span',
                    null,
                    this.state.index + 1
                ),
                ' / ',
                React.createElement(
                    'span',
                    null,
                    this.props.data.length
                )
            ),
            React.createElement(Close, {
                style: {
                    position: 'absolute',
                    top: '0px',
                    right: '0px',
                    padding: '10px',
                    color: '#FFFFFF',
                    cursor: 'pointer',
                    fontSize: this.state.iconSize + 'px'
                },
                onClick: this.props.onCloseCallback }),
            React.createElement(NavigateBefore, {
                style: {
                    position: 'absolute',
                    left: '0px',
                    zIndex: 1,
                    color: '#FFFFFF',
                    cursor: 'pointer',
                    fontSize: this.state.iconSize + 'px'
                },
                onClick: function onClick() {
                    _this9.swipeLeft();
                } }),
            React.createElement(NavigateNext, {
                style: {
                    position: 'absolute',
                    right: '0px',
                    zIndex: 1,
                    color: '#FFFFFF',
                    cursor: 'pointer',
                    fontSize: this.state.iconSize + 'px'
                },
                onClick: function onClick() {
                    _this9.swipeRight();
                } }),
            resources[this.state.index]
        );
    };

    return ReactImageVideoLightbox;
}(React.Component);

export default ReactImageVideoLightbox;